import { EmployeeDropdownDto } from './EmployeeDropdownDto';
import { EmployeeTraining } from '../models/employee-training.model';

/**
 * WI #31500 - single shared conversion from an employee dropdown row
 * (EmployeeDropdownDto) to an EmployeeTraining sign-in-sheet row.
 *
 * Used by BOTH the manual "Add Employee" dialog and the new QR-scan path so the
 * two produce an identical row (AC5 - no regression to manual add). Enrollment
 * and signature ids start null; they are filled once the row is enrolled/signed.
 * last4SSN is read from Last4SSN (Bug 34975: employee/dropdown no longer returns
 * the full SSN) and defaults to '' so a resolved employee without one never
 * throws (AC4 - no crash).
 */
export function employeeDropdownToEmployeeTraining(
  dto: EmployeeDropdownDto
): EmployeeTraining {
  return {
    employeeID: dto.Id,
    hrRef: dto.HRRef,
    firstName: dto.FirstName,
    lastName: dto.LastName,
    fullName: dto.FullName,
    jobClass: null,
    shift: null,
    trainingId: null,
    signatureFileId: null,
    absorbUserId: null,
    dispatchStatus: null,
    last4SSN: dto.Last4SSN ?? '',
    vpJobID: null,
    vpCompanyID: null,
    trainingEnrollmentId: null,
    signedOn: null,
  } as EmployeeTraining;
}
